export default __webpack_public_path__ + "static/media/light-side.eebc5217.jpg";